function documentParts (data, key) {
  const document = data.documents[key]
  if (!document) throw new Error('协议类型无效')
  return { document, operator: data.operator }
}

function legalDocumentText (data, key) {
  const { document, operator } = documentParts(data, key)
  const lines = [document.title, '', '版本：' + data.version, '更新日期：' + data.updatedAt, '生效日期：' + data.effectiveAt,
    '运营单位：' + operator.name, '联系电话：' + operator.phoneDisplay, '电子邮箱：' + operator.email, '', ...document.introduction, '', '请重点阅读', ...document.highlights.map(text => '• ' + text)]
  for (const section of document.sections) {
    lines.push('', section.title, ...(section.paragraphs || []))
    if (section.items) lines.push(...section.items.map((text, index) => (index + 1) + '. ' + text))
    if (section.table) {
      for (const row of section.table.rows) lines.push('', ...row.map((text, index) => section.table.headers[index] + '：' + text))
    }
    lines.push(...(section.after || []))
  }
  lines.push('', '参考法规', ...data.references.map(item => item.title + '：' + item.url))
  return lines.join('\r\n') + '\r\n'
}

function legalDocumentMarkdown (data, key) {
  const { document, operator } = documentParts(data, key)
  const lines = ['# ' + document.title, '', '版本：' + data.version + '　更新日期：' + data.updatedAt + '　生效日期：' + data.effectiveAt, '',
    '运营单位：' + operator.name + '　联系电话：' + operator.phoneDisplay + '　电子邮箱：' + operator.email, '', ...document.introduction.flatMap(text => [text, '']),
    '**请重点阅读：**', '', ...document.highlights.map(text => '- ' + text)]
  const cell = text => String(text).replace(/\|/g, '\\|').replace(/\r?\n/g, '<br>')
  for (const section of document.sections) {
    lines.push('', '## ' + section.title, '', ...(section.paragraphs || []).flatMap(text => [text, '']))
    if (section.items) lines.push(...section.items.map(text => '- ' + text), '')
    if (section.table) lines.push('| ' + section.table.headers.map(cell).join(' | ') + ' |', '| ' + section.table.headers.map(() => '---').join(' | ') + ' |', ...section.table.rows.map(row => '| ' + row.map(cell).join(' | ') + ' |'), '')
    lines.push(...(section.after || []).flatMap(text => [text, '']))
  }
  lines.push('', '## 参考法规', '', ...data.references.map(item => '- [' + item.title + '](' + item.url + ')'), '')
  return lines.join('\n')
}

module.exports = { legalDocumentText, legalDocumentMarkdown }
